import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';

// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import Academyworkflow from './compontent/academyworkflow';
import Golfcoachworkflow from './compontent/golfcoachworkflow';
import SScoachworkflow from './compontent/sscoachworkflow';
import Tpsycholoworkflow from './compontent/tpsycholoworkflow';
import Tnutrntonworkflow from './compontent/tnutrnworkflow';
import Studentworkflow from './compontent/studentworkflow';
import VistStudworkflow from './compontent/viststudworkflow';

import { RctCard, RctCardContent } from 'Components/RctCard';

import {
   allRoles,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

function getWorkflows() {
   return ['Academy Admin', 'Golf Coach', 'SS Coach', 'Psychologist', 'Nutritionist', 'Students', 'Visiting Students'];
}

class workflow extends Component {

   constructor(props) {

      super(props);
      this.state = {

         listdiv: true,
         academydiv: false,
         golfcoachdiv: false,
         sscoachdiv: false,
         psychologistdiv: false,
         nutritionistdiv: false,
         studentdiv: false,
         vststuddiv: false,

      };

      this.openworkflow = this.openworkflow.bind(this);
   }

   openworkflow(id) {

      if (id == 0) {
         this.setState({
            listdiv: false,
            academydiv: true
         });
      } else if (id == 1) {
         this.setState({
            listdiv: false,
            golfcoachdiv: true
         });
      } else if (id == 2) {
         this.setState({
            listdiv: false,
            sscoachdiv: true
         });
      } else if (id == 3) {
         this.setState({
            listdiv: false,
            psychologistdiv: true
         });
      } else if (id == 4) {
         this.setState({
            listdiv: false,
            nutritionistdiv: true
         });
      } else if (id == 5) {
         this.setState({
            listdiv: false,
            studentdiv: true
         });
      } else if (id == 6) {
         this.setState({
            listdiv: false,
            vststuddiv: true
         });
      }

   }

   handleBackMain = () => {
      this.setState({
         vststuddiv: false,
         studentdiv: false,
         nutritionistdiv: false,
         psychologistdiv: false,
         sscoachdiv: false,
         academydiv: false,
         golfcoachdiv: false,
         listdiv: true
      });
   };

   render() {

      const { match, rolelists, loading } = this.props;
      const role = localStorage.getItem('user_role');
      const workflowlist = getWorkflows();

      return (
         <div className="saas-dashboard">
            <Helmet>
               <title>Workflow | {AppConfig.appTitle}</title>
               <meta name="description" content="Reactify Sass Dashboard" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.workflowheading" />} match={match} />
            <div className="row">
               {this.state.listdiv &&
                  <div className="col-sm-12 col-md-8" style={{ margin: "0 auto" }}>
                     <RctCollapsibleCard>
                        <div className="row">
                           {workflowlist.map((label, index) => {
                              if ((role === '5' || role === '6') && index !== 5 && index !== 6) {
                                 return null;
                              }else if(role === '2' && index==0){
                                 return null;  
                              } else {
                                 return (
                                    <div key={index} className="col-sm-12 col-md-6 col-lg-3">

                                       <a href="#" onClick={() => this.openworkflow(index)}>
                                          <RctCard>
                                             <RctCardContent>
                                                <div className="client-post text-center">
                                                   <div className="client-content">
                                                   <h4 className="fw-bold text-capitalize" style={{ color: "#505971" }}>{label}</h4>
                                                   </div>
                                                </div>
                                             </RctCardContent>
                                          </RctCard>
                                       </a>
                                    </div>
                                 );
                              }
                           })}
                        </div>
                     </RctCollapsibleCard>
                  </div>
               }
               {this.state.academydiv &&
                  <div className="col-sm-12 col-md-8" style={{ margin: "0 auto" }}>
                     <RctCollapsibleCard heading="Academy Admin">
                        <Academyworkflow onClick={this.handleBackMain} />
                     </RctCollapsibleCard>
                  </div>
               }

               {this.state.golfcoachdiv &&
                  <div className="col-sm-12 col-md-8" style={{ margin: "0 auto" }}>
                     <RctCollapsibleCard heading="Golf Coach">
                        <Golfcoachworkflow onClick={this.handleBackMain} />
                     </RctCollapsibleCard>
                  </div>
               }

               {this.state.sscoachdiv &&
                  <div className="col-sm-12 col-md-8" style={{ margin: "0 auto" }}>
                     <RctCollapsibleCard heading="SS Coach">
                        <SScoachworkflow onClick={this.handleBackMain} />
                     </RctCollapsibleCard>
                  </div>
               }

               {this.state.psychologistdiv &&
                  <div className="col-sm-12 col-md-8" style={{ margin: "0 auto" }}>
                     <RctCollapsibleCard heading="Psychologist">
                        <Tpsycholoworkflow onClick={this.handleBackMain} />
                     </RctCollapsibleCard>
                  </div>
               }

               {this.state.nutritionistdiv &&
                  <div className="col-sm-12 col-md-8" style={{ margin: "0 auto" }}>
                     <RctCollapsibleCard heading="Nutritionist">
                        <Tnutrntonworkflow onClick={this.handleBackMain} />
                     </RctCollapsibleCard>
                  </div>
               }

               {this.state.studentdiv &&
                  <div className="col-sm-12 col-md-8" style={{ margin: "0 auto" }}>
                     <RctCollapsibleCard heading="Students">
                        <Studentworkflow onClick={this.handleBackMain} />
                     </RctCollapsibleCard>
                  </div>
               }

               {this.state.vststuddiv &&
                  <div className="col-sm-12 col-md-8" style={{ margin: "0 auto" }}>
                     <RctCollapsibleCard heading="Students">
                        <VistStudworkflow onClick={this.handleBackMain} />
                     </RctCollapsibleCard>
                  </div>
               }

            </div>
         </div>
      )
   }
}




const mapStateToProps = ({ role }) => {
   const { rolelists, loading } = role;
   return { rolelists, loading };
}

export default connect(mapStateToProps, {
   allRoles,
})(workflow); 